/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UgcTemplateFilter = exports.State = exports.SortableField = exports.SortOrder = exports.PublishedFilter = exports.PremiumFeature = exports.PremiumAssignedFilter = exports.ParentAccountIdFilter = exports.Namespace = exports.MetaSiteStateFilter = exports.EditorTypeFilter = exports.EditorType = exports.DomainConnectedFilter = exports.DocumentTypeFilter = exports.DocumentType = exports.DeleteStatus = void 0;
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus = exports.DeleteStatus || (exports.DeleteStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["UNKNOWN_DOC_TYPE"] = "UNKNOWN_DOC_TYPE";
    DocumentType["UGC"] = "UGC";
    DocumentType["Template"] = "Template";
    DocumentType["WixSite"] = "WixSite";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var DocumentTypeFilter;
(function (DocumentTypeFilter) {
    DocumentTypeFilter["NO_DOCUMENT_TYPE_FILTER"] = "NO_DOCUMENT_TYPE_FILTER";
    DocumentTypeFilter["UGC"] = "UGC";
    DocumentTypeFilter["Template"] = "Template";
    DocumentTypeFilter["WixSite"] = "WixSite";
})(DocumentTypeFilter = exports.DocumentTypeFilter || (exports.DocumentTypeFilter = {}));
var DomainConnectedFilter;
(function (DomainConnectedFilter) {
    DomainConnectedFilter["UNKNOWN_DOMAIN_CONNECTED_FILTER"] = "UNKNOWN_DOMAIN_CONNECTED_FILTER";
    DomainConnectedFilter["DOMAIN_CONNECTED"] = "DOMAIN_CONNECTED";
    DomainConnectedFilter["NO_DOMAIN_CONNECTED"] = "NO_DOMAIN_CONNECTED";
})(DomainConnectedFilter = exports.DomainConnectedFilter || (exports.DomainConnectedFilter = {}));
var EditorType;
(function (EditorType) {
    EditorType["UNKNOWN"] = "UNKNOWN";
    EditorType["EDITOR"] = "EDITOR";
    EditorType["ADI"] = "ADI";
    EditorType["EDITORX"] = "EDITORX";
})(EditorType = exports.EditorType || (exports.EditorType = {}));
var EditorTypeFilter;
(function (EditorTypeFilter) {
    EditorTypeFilter["NO_EDITOR_TYPE_FILTER"] = "NO_EDITOR_TYPE_FILTER";
    EditorTypeFilter["EDITOR"] = "EDITOR";
    EditorTypeFilter["ADI"] = "ADI";
    EditorTypeFilter["EDITORX"] = "EDITORX";
    EditorTypeFilter["NO_EDITOR"] = "NO_EDITOR";
})(EditorTypeFilter = exports.EditorTypeFilter || (exports.EditorTypeFilter = {}));
var MetaSiteStateFilter;
(function (MetaSiteStateFilter) {
    MetaSiteStateFilter["UNKNOWN"] = "UNKNOWN";
    MetaSiteStateFilter["ACTIVE"] = "ACTIVE";
    MetaSiteStateFilter["TRASHED"] = "TRASHED";
    MetaSiteStateFilter["DELETED"] = "DELETED";
})(MetaSiteStateFilter = exports.MetaSiteStateFilter || (exports.MetaSiteStateFilter = {}));
var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["WIX"] = "WIX";
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    Namespace["ALBUMS"] = "ALBUMS";
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    Namespace["HOTELS"] = "HOTELS";
    Namespace["CLUBS"] = "CLUBS";
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    Namespace["DEV_SITE"] = "DEV_SITE";
    Namespace["LOGOS"] = "LOGOS";
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    Namespace["ANYWHERE"] = "ANYWHERE";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
var ParentAccountIdFilter;
(function (ParentAccountIdFilter) {
    ParentAccountIdFilter["UNKNOWN_PARENT_ACCOUNT_ID_FILTER"] = "UNKNOWN_PARENT_ACCOUNT_ID_FILTER";
    ParentAccountIdFilter["HAS_PARENT_ACCOUNT"] = "HAS_PARENT_ACCOUNT";
    ParentAccountIdFilter["HAS_NO_PARENT_ACCOUNT"] = "HAS_NO_PARENT_ACCOUNT";
})(ParentAccountIdFilter = exports.ParentAccountIdFilter || (exports.ParentAccountIdFilter = {}));
var PremiumAssignedFilter;
(function (PremiumAssignedFilter) {
    PremiumAssignedFilter["UNKNOWN_PREMIUM_ASSIGNED_FILTER"] = "UNKNOWN_PREMIUM_ASSIGNED_FILTER";
    PremiumAssignedFilter["ONLY_PREMIUM_ASSIGNED"] = "ONLY_PREMIUM_ASSIGNED";
    PremiumAssignedFilter["ONLY_NON_PREMIUM_ASSIGNED"] = "ONLY_NON_PREMIUM_ASSIGNED";
})(PremiumAssignedFilter = exports.PremiumAssignedFilter || (exports.PremiumAssignedFilter = {}));
var PremiumFeature;
(function (PremiumFeature) {
    PremiumFeature["UNKNOWN_PREMIUM_FEATURE"] = "UNKNOWN_PREMIUM_FEATURE";
    PremiumFeature["SHOW_WIX_WHILE_LOADING"] = "SHOW_WIX_WHILE_LOADING";
    PremiumFeature["ADS_FREE"] = "ADS_FREE";
    PremiumFeature["HAS_ECOMMERCE"] = "HAS_ECOMMERCE";
    PremiumFeature["HAS_DOMAIN"] = "HAS_DOMAIN";
    PremiumFeature["ALWAYS_SHOW_FOOTER"] = "ALWAYS_SHOW_FOOTER";
    PremiumFeature["NO_ADS_IN_SOCIAL_SITES"] = "NO_ADS_IN_SOCIAL_SITES";
})(PremiumFeature = exports.PremiumFeature || (exports.PremiumFeature = {}));
var PublishedFilter;
(function (PublishedFilter) {
    PublishedFilter["NO_PUBLISH_FILTER"] = "NO_PUBLISH_FILTER";
    PublishedFilter["PUBLISHED"] = "PUBLISHED";
    PublishedFilter["NOT_PUBLISHED"] = "NOT_PUBLISHED";
})(PublishedFilter = exports.PublishedFilter || (exports.PublishedFilter = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "Ascending";
    SortOrder["Descending"] = "Descending";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var SortableField;
(function (SortableField) {
    SortableField["Id"] = "Id";
    SortableField["DeletionDate"] = "DeletionDate";
    SortableField["CreationDate"] = "CreationDate";
    SortableField["UpdateDate"] = "UpdateDate";
    SortableField["DisplayName"] = "DisplayName";
    SortableField["EditorLastSaveDate"] = "EditorLastSaveDate";
    SortableField["ParentAccountId"] = "ParentAccountId";
    SortableField["UgcTemplate"] = "UgcTemplate";
})(SortableField = exports.SortableField || (exports.SortableField = {}));
var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["TEMPLATE"] = "TEMPLATE";
    State["PENDING"] = "PENDING";
})(State = exports.State || (exports.State = {}));
var UgcTemplateFilter;
(function (UgcTemplateFilter) {
    UgcTemplateFilter["UNKNOWN_UGC_TEMPLATE_FILTER"] = "UNKNOWN_UGC_TEMPLATE_FILTER";
    UgcTemplateFilter["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    UgcTemplateFilter["NOT_UGC_TEMPLATE"] = "NOT_UGC_TEMPLATE";
})(UgcTemplateFilter = exports.UgcTemplateFilter || (exports.UgcTemplateFilter = {}));
//# sourceMappingURL=types.js.map